import React from "react";
import "../App.css";
import "../utils/styles/PageAnimations.css";

function ImprintPage() {
  return (
    <div
      className="imprint-page page-animated"
      style={{
        padding: "5rem 1rem",
        maxWidth: "1100px",
        margin: "0 auto",
      }}
    >
      <h1
        className="animate-up delay-1"
        style={{
          textAlign: "center",
          marginBottom: "1rem",
          fontSize: "3rem",
          color: "#1d2b45",
        }}
      >
        Impressum
      </h1>

      <div
        className="animate-up delay-2 hover-card"
        style={{
          background: "rgba(255,255,255,0.92)",
          borderRadius: "28px",
          padding: "3rem",
          boxShadow: "0 10px 30px rgba(31,152,244,0.08)",
          border: "1px solid rgba(3,122,246,0.08)",
          backdropFilter: "blur(10px)",
        }}
      >
        <div
          style={{
            display: "grid",
            gap: "1.5rem",
          }}
        >
          <div
            className="hover-card"
            style={{
              padding: "1rem",
              borderRadius: "18px",
              background: "#f7fbff",
              border: "1px solid rgba(3,122,246,0.08)",
            }}
          >
            <h2
              style={{
                color: "#037af6",
                fontSize: "1.5rem",
              }}
            >
              🏢 Unternehmen
            </h2>
            <br />
            <p style={{ lineHeight: "1.9", color: "#42526b" }}>
              Angaben gemäß § 5 DDG
              <br /> <br />
              oneNizer
              <br />
              c/o V12 GbR
              <br />
              Van Dat Nguyen
              <br />
              Viktoriastraße 12
              <br />
              65189 Wiesbaden
              <br />
              Deutschland
            </p>
            <br />
            <h2
              style={{
                color: "#037af6",
                fontSize: "1.5rem",
              }}
            >
              📬 Kontakt
            </h2>
            <br />
            <p style={{ lineHeight: "1.9", color: "#42526b" }}>
              E-Mail:
              <a
                href="mailto:support@onenizer.com?subject=Support%20oneNizer"
                style={{ marginLeft: "6px" }}
              >
                support@onenizer.com
              </a>
              <br />
              Telefon: 0171 - 779 79 34
            </p>
            <br />
            <br />
            <strong>
              Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:
            </strong>
            <br />
            Umsatzsteuer-ID: DE268908187
            <br /> <br />
            Haftungshinweis: Wir sind für die Inhalte unserer Internetseiten
            nach den Maßgaben der allgemeinen Gesetze verantwortlich. Alle
            Inhalte werden mit der gebotenen Sorgfalt und nach bestem Wissen
            erstellt. Soweit wir auf unseren Internetseiten mittels Hyperlinks
            auf Internetseiten Dritter verweisen, können wir keine Gewähr für
            die fortwährende Aktualität, Richtigkeit und Vollständigkeit der
            verlinkten Inhalte übernehmen, da diese Inhalte außerhalb unseres
            Verantwortungsbereichs liegen und wir auf die zukünftige Gestaltung
            keinen Einfluss haben. Sollten aus Ihrer Sicht Inhalte gegen
            geltendes Recht verstoßen oder unangemessen sein, teilen Sie uns
            dies bitte mit.
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImprintPage;
